import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  saveCulture: ['culture', 'onSuccess', 'onError'],
  removeCulture: ['culture', 'onSuccess', 'onError'],
  cultureError: ['error']
})

const saveCulture = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeCulture = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const cultureError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.CULTURE_ERROR]: cultureError,

  [Types.SAVE_CULTURE]: saveCulture,
  [Types.REMOVE_CULTURE]: removeCulture,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as CultureTypes,
  Creators as CultureActions
}
